import {apiRegister} from '../../common/api'
import {XUtils} from "../../common/globals"

/**
 * 设置微信提醒
 * @funcType {1：是猜涨跌}
 */

export const wxRemind = apiRegister('wxRemind', {
    protoId: 1216,
    path: '/message/sub/my/',
    formatQuery: function addQueryCorp(q) {
        q = q || {}
        q.corp = XUtils.getConst('CORP')
        return q
    }
}).send